import { Box, SxProps, Theme, Typography } from '@mui/material';

interface SectionHeaderProps {
  title: string;
  sx?: SxProps<Theme>;
  img?: string;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({ title, sx, img }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      minHeight: '3rem',
      bgcolor: '#1A55F9',
      color: 'white',
      px: 2,
      py: 1,
      borderTopLeftRadius: '8px',
      borderTopRightRadius: '8px',
      fontWeight: 'bold',
      ...sx, // Allow overrides via prop
    }}
  >
    <i className="pi pi-bullseye" style={{ marginRight: '8px' }} />
    {img && <img src={img} style={{ marginRight: '8px' }} />}
    <Typography>{title}</Typography>
  </Box>
);

export default SectionHeader;
